import React from 'react';

import { Select, Grid, Typography } from '@gogame/components';

export const PathBuilder = ({
  dimensions,
  drillTo,
  nextLevel,
  onChangeNextLevel,
  dimensionValue,
  onChangeDimension,
}) => {
  return (
    <Grid spacing={2} container>
      <Grid item sx={{ width: 160 }}>
        <Select
          dropdownWidth={256}
          options={dimensions}
          onChange={onChangeDimension}
          value={dimensionValue}
          label={'Dimension'}
        />
      </Grid>
      <Grid item sx={{ display: 'flex' }}>
        <Typography sx={{ alignSelf: 'center' }}>/</Typography>
      </Grid>
      <Grid item sx={{ width: 160 }}>
        <Select
          dropdownWidth={256}
          options={drillTo}
          onChange={(_, v) => onChangeNextLevel(v)}
          value={nextLevel}
          label={'Next level'}
        />
      </Grid>
    </Grid>
  );
};
